module.exports = __webpack_public_path__ + "static/img/student-default-avatar.bf833cde.png";